export const X3Small = 1;
export const X2Small = 2;
export const XSmall = 4;
export const Small = 8;
export const Medium = 12;
export const Large = 16;
export const XLarge = 20;
export const X2Large = 24;
export const X3Large = 28;
export const X4Large = 32;
export const X5Large = 36;
export const X6Large = 40;
export const X7Large = 48;
export const X8Large = 64;
